import { z } from 'zod';

/** Platform roles (docs/08-SECURITY.md §3). Stored on memberships; evaluated by the policy engine. */
export const ROLES = [
  'platform_admin',
  'org_admin',
  'knowledge_admin',
  'workflow_admin',
  'architect',
  'reviewer',
  'viewer',
] as const;
export const Role = z.enum(ROLES);
export type Role = z.infer<typeof Role>;

export const ClientKind = z.enum(['mcp_client', 'web_admin']);
export type ClientKind = z.infer<typeof ClientKind>;

/** Safe identity summary. Never contains tokens, token ids, secrets or raw claims. */
export const IdentitySummary = z.object({
  principal: z.object({
    userId: z.string().uuid(),
    email: z.string().nullable(),
    displayName: z.string().nullable(),
  }),
  client: z.object({ clientId: z.string(), kind: ClientKind }),
  organization: z.object({ id: z.string().uuid(), slug: z.string(), name: z.string() }).nullable(),
  roles: z.array(Role),
  /** High-level capabilities granted by policy for this principal × client × organization. */
  capabilities: z.array(z.string()),
});
export type IdentitySummary = z.infer<typeof IdentitySummary>;

export const SessionInfo = IdentitySummary.extend({
  csrfToken: z.string(),
  expiresAt: z.iso.datetime(),
});
export type SessionInfo = z.infer<typeof SessionInfo>;
